import { createGlobalState } from './createGlobalState';
import { Environment } from 'core/models/environment';
import { Project } from 'core/models/project';
import { useEffect } from 'react';
import { useEnvironmentRepository } from './useEnvironmentRepository';
import { cancellable } from './utility/cancellable';

const { useWithState, useDispatch, useState } = createGlobalState<Environment[] | undefined>((_, a) => a, undefined);

export { useWithState as useWithEnvironments };

export function useEnvironments(projectId: Project.Id | undefined) {
    const environments = useState();
    const setEnvironments = useDispatch();

    const repository = useEnvironmentRepository();

    useEffect(() => {
        if (projectId === undefined) {
            setEnvironments([]);
            return;
        }
        return cancellable(async isCancel => {
            const environments = await repository.getEnvironments(projectId);
            if (isCancel()) return;
            setEnvironments(environments);
        });
    }, [repository, projectId, setEnvironments]);

    return environments || [];
}
